import { Channel, HomeNotification } from '../stores/reducers/home';
import { getHeaders } from './utils';

export const CreateNotification = (token: string, notification: HomeNotification) => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/notifications/create`, {
		method: 'POST',
		headers: getHeaders(token) as any,
		body: JSON.stringify({ notification }),
	}).then(result => {
		if (!result.ok) {
			throw new Error('Unable to create notification');
		}
	}).catch(error => {
		console.error(error);
	});
};

export const LoadNotifications = (token: string) => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/notifications/get`, {
		method: 'GET',
		headers: getHeaders(token) as any,
	}).then(async result => {
		if (result.ok) {
			const notifications = await result.json();
			const cleanedNotifications = notifications.map((notification: any) => {
				notification.data = JSON.parse(notification.data);
				return notification;
			});
			return cleanedNotifications;
		} else {
			throw new Error('Unable to create notification');
		}
	}).catch(error => {
		console.error(error);
	});
};

export const SetNotificationsSeen = (token: string, notificationIDs: number[]) => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/notifications/set-seen`, {
		method: 'POST',
		headers: getHeaders(token) as any,
		body: JSON.stringify({ notificationIDs }),
	}).then(result => {
		if (!result.ok) {
			throw new Error('Unable to set notifications as seen');
		} else {
			return true;
		}
	}).catch(error => {
		console.error(error);
	});
};

export const FindUser = (token: string, email: string) => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/home/find-user`, {
		method: 'POST',
		headers: getHeaders(token) as any,
		body: JSON.stringify({ email }),
	}).then(result => {
		if (!result.ok) {
			throw new Error('Unable to get user');
		} else {
			return result.json();
		}
	}).catch(error => {
		console.error(error);
	});
};

export const LoadTeams = (token: string, channels: { events_legacy_channels: Channel[], gr_channels: Channel[] }) => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/home/load-teams`, {
		method: 'POST',
		headers: getHeaders(token) as any,
		body: JSON.stringify({ channels }),
	}).then(result => {
		if (!result.ok) {
			throw new Error('Unable to load teams');
		} else {
			return result.json();
		}
	}).catch(error => {
		console.error(error);
	});
};
